import * as React from "react";
import { forwardRef } from "react";
const SvgAirplaneIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 16, viewBox: "0 0 19 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.674837 15.5L18.1665 8L0.674837 0.5L0.666504 6.33333L13.1665 8L0.666504 9.66667L0.674837 15.5Z", fill: "#0089AB" }));
const ForwardRef = forwardRef(SvgAirplaneIcon);
export default ForwardRef;
